import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { ConnectorsListQuery } from 'src/services/DOM/queries/connectorsList';
import { connectorsListQuery } from 'src/services/DOM/queries/connectorsList/__generated__/connectorsListQuery.graphql';
import { enhanceDraftConnectorList } from '../../utils/enhanceDraftConnectorList';
import { orderConnectorList } from '../../utils/orderConnectorList';
import { buildConnectorsList } from '../../utils/buildConnectorsList';

export const useConnectorInventoryListProd = (canAddConnector: boolean) => {
  const [draftConnectorList, setDraftConnectorList] = useState([]);

  useEffect(() => {
    axios.get('/api/v1/dom/draft/list').then((result) => {
      setDraftConnectorList(result.data);
    });
  }, []);

  const { connectors } = useLazyLoadQuery<connectorsListQuery>(
    ConnectorsListQuery,
    {}
  );

  const mappedDraftConnectorList = useMemo(
    () => enhanceDraftConnectorList(draftConnectorList),
    [draftConnectorList]
  );

  const mappedConnectorList = useMemo(
    () => buildConnectorsList(connectors, canAddConnector),
    [connectors, canAddConnector]
  );

  const data = useMemo(
    () => orderConnectorList(mappedDraftConnectorList, mappedConnectorList),
    [connectors, draftConnectorList]
  );

  return {
    data,
    error: false,
  };
};
